import React from 'react'
import Body from '../Body/Body'
import Header from '../Header/Header'
import './Home.css'


function Home() {
  return (
    <div className="primary-container">
        <Header />
        <Body />
    </div>
  )
}

export default Home